import { IValidatorFunc } from '@bp/shared/features/validation/models';

import { MetadataEntity } from '../metadata-entity';

import { $$classMetadataPropertyMetadataControlInjector } from './class-metadata-property-metadata-control-injector';
import { PropertyMetadataMapper } from './property-metadata.decorator';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Validator(validator: IValidatorFunc<any>): PropertyMetadataMapper {
	return function(model: MetadataEntity, property: string): void {
		$$classMetadataPropertyMetadataControlInjector(
			model,
			property,
			{ validator },
		);
	};
}
